import type { JSONObject, JSONValue } from '../types/json';

function isObject(value: JSONValue): value is JSONObject {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

export function capitalize(word: string): string {
  if (!word) {
    return '';
  }

  return `${word[0].toUpperCase()}${word.slice(1)}`;
}

export function decapitalize(word: string): string {
  if (!word) {
    return '';
  }

  return `${word[0].toLowerCase()}${word.slice(1)}`;
}

export function snakeCaseToCamelCase(str: string): string {
  const camelCaseString = str.split('_').map(capitalize).join('');

  return decapitalize(camelCaseString);
}

function isIterable(value: JSONValue): value is JSONValue[] | JSONObject {
  return Array.isArray(value) || isObject(value);
}

export function snakeCaseObjectToCamelCase<R = JSONObject | JSONValue[]>(
  obj: JSONObject | JSONValue[]
): R {
  return Object.entries(obj)
    .map(([key, val]) => {
      let value = val;
      if (isIterable(value)) {
        value = snakeCaseObjectToCamelCase(value);
      }

      return { [snakeCaseToCamelCase(key)]: value };
    })
    .reduce(
      (accumulator, currentValue) => Object.assign(accumulator, currentValue),
      Array.isArray(obj) ? [] : {}
    ) as R;
}
